import { render, staticRenderFns } from "./HitDetectorWidgetComponent.vue?vue&type=template&id=6b3f61d6&scoped=true&"
import script from "./HitDetectorWidgetComponent.vue?vue&type=script&lang=ts&"
export * from "./HitDetectorWidgetComponent.vue?vue&type=script&lang=ts&"
import style0 from "./HitDetectorWidgetComponent.vue?vue&type=style&index=0&id=6b3f61d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3f61d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
